import { useEffect, useRef, useState } from "react";
import { Tooltip, Button } from "@material-tailwind/react";
import { DecisionPointTab, delete_user_data_from_client_side, errorToast, get_user_data } from "../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
// import { generateNewDecisionPointUsingAI } from "../../../api";
import { AppDispatch, RootState } from "../../../state/store";
import { updateCaselet } from "../caseletSlice";
import { LoadingScreen } from "../../thoughts/chat/LoadingScreen";
import { handleUpdateCaseletClick } from "../../thoughts/chat/ChatCardButton";
import DecisionPointTabs from "../../../design-system/Button/DecisionPointTabs";
import DecisionPoint from "./DecisionPoint";
import { useNavigate } from "react-router-dom";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { usePrompt } from "../../../utils/usePrompt";
import Alert from "../../../design-system/Alert";
import { generateNewDecisionPointUsingAI } from "../../../api/axiosApi";
export interface ChallengesProps {
    challenges: DecisionPointTab[];
    published: boolean;
    sendChallengeDataToParent: (data: boolean) => void;
    caseletId: string;
    respForNewOptionCreated: (flag: boolean) => void;
}
export interface NewDecisionPointFormValues {
    title: string;
    challenge: string;
    options?: string[];
    videos?: string[];
}
interface Tab {
    title: string;
}

export const forceRerender = () => {
    const [triggerRender, setTriggerRender] = useState(true);
    setTriggerRender(!triggerRender);
};

const Challenges = ({ challenges, published, caseletId, respForNewOptionCreated, sendChallengeDataToParent }: ChallengesProps) => {
    const inActiveToolTipStyle = "p-2 bg-gray-500 font-bold text-xs";
    const activeToolTipStyle = "p-2 bg-green-800 font-bold text-xs";
    const [isPreviousChallengeEmpty, setIsPreviousChallengeEmpty] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [challengeAction, setChallengeAction] = useState("");
    const [addNewDecisionButtonStyle, setAddNewDecisionButtonStyle] = useState("");
    const [generateNewDecisionButtonStyle, setGenerateNewDecisionButtonStyle] = useState("");
    const [addNewDecisionToolTipStyle, setAddNewDecisionToolTipStyle] = useState("");
    const [generateNewDecisionTooltipStyle, setGenerateNewDecisionTooltipStyle] = useState("");
    const [addNewDecisionPointToolTipMessage, setAddNewDecisionPointToolTipMessage] = useState("");
    const [generateNewDecisionTooltipMessage, setGenerateNewDecisionTooltipMessage] = useState("");
    const [generatingNewDecisionPoint, setGeneratingNewDecisionPoint] = useState(false);
    const [newOptionFlag, setNewOptionFlag] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [isLeftDisabled, setIsLeftDisabled] = useState(true);
    const [isRightDisabled, setIsRightDisabled] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [loading, setLoading] = useState(false);
    const generateDecisionButtonName = "Generate";
    const [flag, setFlag] = useState(false);
    let decisionPointsFromLocalStorage: any[] = [];
    const [decisionPointsFromLocalStorageState, setDecisionPointsFromLocalStorageState] = useState<any[]>([]);
    const [activeTab, setActiveTab] = useState(
        JSON.parse(localStorage.getItem(`${caseletId}decisionPointName`) || JSON.stringify(challenges[0])) || challenges[0]
    );
    const caseletData = useSelector((state: RootState) => state.caselet);
    const [newlyCreatedDecisionTitle, setNewlyCreatedDecisionTitle] = useState("");
    const navigate = useNavigate();
    let warningPrompt = false;
    const tabRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
    const scrollToActiveTab = () => {
        const activeTabRef = tabRefs.current[activeTab.title];
        if (activeTabRef && document.body.contains(activeTabRef)) {
            const tabsContainer = document.querySelector(".tabs-container");
            if (tabsContainer) {
                tabsContainer.scrollLeft = activeTabRef.offsetLeft - 125;
            }
        }
    };
    usePrompt({
        when: isPreviousChallengeEmpty || newOptionFlag
    });
    function setActiveTabFromDecisionPoint(data: number) {
        setActiveTab(challenges[data]);
    }
    function getNewOptionFlag(resp: boolean) {
        const updatedCaselet = JSON.parse(JSON.stringify(caseletData));

        if (updatedCaselet.challenges[updatedCaselet.challenges.length - 1].challenge.length === "") {
            setFlag(true);
        } else {
            setFlag(false);
        }
        if (flag) {
            if (updatedCaselet.challenges[updatedCaselet.challenges.length - 1].challenge.length !== "") {
                respForNewOptionCreated(resp);
                setNewOptionFlag(resp);
            } else {
                respForNewOptionCreated(false);
                setNewOptionFlag(false);
            }
        } else {
            respForNewOptionCreated(resp);
            setNewOptionFlag(resp);
        }
        if (resp) {
            for (var key of Object.keys(localStorage)) {
                if (key.includes("Decision Point")) {
                    console.log("DSP: ", key.split("-")[1]);
                    if (!decisionPointsFromLocalStorage.includes(key.split("-")[1])) decisionPointsFromLocalStorage.push(key.split("-")[1]);
                    // break;
                }
            }
            console.log("decisionPointsFromLocalStorage: ", decisionPointsFromLocalStorage, newOptionFlag);
            setDecisionPointsFromLocalStorageState(decisionPointsFromLocalStorage);
        } else {
            setDecisionPointsFromLocalStorageState([]);
        }
    }
    const slideLeft = () => {
        var slider = document.getElementById("slider");
        if (slider !== null) slider.scrollLeft = slider.scrollLeft - 800;
    };

    const slideRight = () => {
        var slider = document.getElementById("slider");
        if (slider !== null) slider.scrollLeft = slider.scrollLeft + 800;
    };

    const checkScrollPosition = () => {
        const slider = document.getElementById("slider");
        if (slider) {
            const isAtStart = slider.scrollLeft === 0;
            const isAtEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth;

            setIsLeftDisabled(isAtStart);
            setIsRightDisabled(isAtEnd);
        }
    };

    const checkOverflow = () => {
        const slider = document.getElementById("slider");
        if (slider) {
            const isOverflowing = slider.scrollWidth > slider.offsetWidth;
            setIsOverflowing(isOverflowing);
        }
        if (slider) {
            slider.addEventListener("scroll", checkScrollPosition);
        }
        return () => {
            if (slider) {
                slider.removeEventListener("scroll", checkScrollPosition);
            }
        };
    };

    useEffect(() => {
        checkOverflow();
        setTimeout(() => {
            scrollToActiveTab();
        }, 300);
        // Scroll to the active tab whenever it changes
        if (localStorage.getItem(`${caseletId}isEmptyDecisionPointExist`) === "true" && challenges[challenges.length - 1].title === activeTab) {
            console.log("challenges.length-1 : ", challenges.length - 1);
            setActiveTabFromDecisionPoint(challenges.length);
        }
        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, [activeTab]);

    const dispatch = useDispatch<AppDispatch>();
    var decisionPointNumber = 0;
    function getNewDecisionPointTitleNumber() {
        if (challenges.length > 0) {
            decisionPointNumber = challenges.length + 1;
        } else {
            decisionPointNumber = 1;
        }

        return decisionPointNumber;
    }
    const newDP = {
        title: "Decision Point " + getNewDecisionPointTitleNumber(),
        challenge: "",
        options: [],
        videos: []
    };

    useEffect(() => {
        if (challenges.length > 0 && challenges[challenges.length - 1].challenge === "") {
            setIsPreviousChallengeEmpty(true);
            setAddNewDecisionPointToolTipMessage("New decision point already created !!");
            setGenerateNewDecisionTooltipMessage("Empty decision point already exists !!");
            setAddNewDecisionToolTipStyle(inActiveToolTipStyle);
            setGenerateNewDecisionTooltipStyle(inActiveToolTipStyle);
            setAddNewDecisionButtonStyle("inactive-challenge-button-style");
            setGenerateNewDecisionButtonStyle("inactive-challenge-button-style");
        } else {
            setIsPreviousChallengeEmpty(false);
            setAddNewDecisionPointToolTipMessage("Add new decision point manually");
            setGenerateNewDecisionTooltipMessage("Generate new decision point using AI");
            setAddNewDecisionToolTipStyle(activeToolTipStyle);
            setGenerateNewDecisionTooltipStyle(activeToolTipStyle);
            setAddNewDecisionButtonStyle("active-challenge-button-style");
            setGenerateNewDecisionButtonStyle("active-challenge-button-style");
        }
    }, [challenges]);

    const handleDiscardChanges = () => {
        for (var key of Object.keys(localStorage)) {
            if (key.includes("Decision Point")) {
                localStorage.removeItem(key);
            }
        }
        localStorage.removeItem(`${caseletId}activeTab`);
        localStorage.removeItem(`${caseletId}decisionPointName`);
        // localStorage.setItem("isEmptyDecisionPointExist","true");
        setNewOptionFlag(false);
        setShowAlert(false);
    };
    useEffect(() => {
        if (challengeAction === "add") {
            newDecisionPoint();
        } else if (challengeAction === "generate") {
            generateNewDecisionPoint();
        }
    }, [showAlert, newOptionFlag]);

    useEffect(() => {
        return () => {
            localStorage.removeItem(`${caseletId}decisionPointName)`);
        };
    }, []);
    const handleStayEditing = () => {
        setNewOptionFlag(true);
        setShowAlert(false);
        setChallengeAction("");
    };

    const handleTabClick = (tab: Tab) => {
        const decisionPoint = challenges.find(dp => dp.title === tab.title);
        if (decisionPoint) {
            localStorage.setItem(`${caseletId}decisionPointName`, JSON.stringify(decisionPoint));
            setActiveTab(decisionPoint);
        }
    };

    const newDecisionPoint = () => {
        setChallengeAction("add");
        if (!newOptionFlag) {
            if (decisionPointNumber !== 0) {
                console.log("value of decisionPointNumber inside", decisionPointNumber);
                const updatedChallenges = [...caseletData.challenges];
                setIsPreviousChallengeEmpty(true);
                sendChallengeDataToParent(true);
                updatedChallenges.push(newDP);
                warningPrompt = true;
                setNewlyCreatedDecisionTitle(newDP.title);
                dispatch(updateCaselet({ ...caseletData, challenges: updatedChallenges }));
                setActiveTab(updatedChallenges[updatedChallenges.length - 1]);
                checkOverflow();
                // setCancelNewOption(false);
                setChallengeAction("");
                localStorage.setItem(`${caseletId}activeTab`, "challenges");
                localStorage.setItem(`${caseletId}isEmptyDecisionPointExist`, "true");
            }
        } else {
            setShowAlert(true);
        }
    };
    async function generateNewDecisionPoint() {
        setChallengeAction("generate");
        console.log("value of newOptionFlag in generating new DP", newOptionFlag);
        if (!newOptionFlag) {
            setGeneratingNewDecisionPoint(true);
            setChallengeAction("");
            setLoading(true);
            setShowAlert(false);
            try {
                if (!caseletData || typeof caseletData !== "object") {
                    throw new Error("Invalid caselet data");
                }
                const userId = get_user_data().email;
                const responseData = await generateNewDecisionPointUsingAI(userId, caseletData.id);
                // if (responseData.status === 401 || responseData.status === 422) {
                //     delete_user_data_from_client_side();
                //     navigate("/user_login");
                // }
                // if (!responseData.ok) {
                //     throw new Error(`Error! status: ${responseData.status}`);
                // }
                const updatedChallenges = [...caseletData.challenges];
                const result = await responseData.data;
                if (result) {
                    newDP.options = result.options;
                    newDP.challenge = result.challenge;
                    updatedChallenges.push(newDP);
                    setActiveTab(updatedChallenges[updatedChallenges.length - 1]);
                } else {
                    errorToast("Challenge Generation Failed");
                    return;
                }
                dispatch(updateCaselet({ ...caseletData, challenges: updatedChallenges }));
                setLoading(false);
                await handleUpdateCaseletClick({ ...caseletData, challenges: updatedChallenges });
                return result;
            } catch (err) {
                errorToast("Challenge Generation Failed caught in catch");
            } finally {
                setLoading(false);
                setGeneratingNewDecisionPoint(false);
            }
        } else {
            setShowAlert(true);
        }
    }

    return (
        <div>
            <div className="grid  grid-cols-4 w-full mt-4">
                <div className="col-span-3 w-full">
                    {isOverflowing ? (
                        <div className="flex items-center justify-center min-w-32 ">
                            <div className="align-middle">
                                <HiChevronLeft
                                    size={40}
                                    className={`scroll_decision_point_button ${!isLeftDisabled && " hover:opacity-80"}`}
                                    onClick={slideLeft}
                                />
                            </div>
                            <div
                                className="flex rounded overflow-x-auto items-center scroll whitespace-nowrap scroll-smooth scrollbar-hide tabs-container "
                                id="slider"
                            >
                                {challenges.map((tab, index) => (
                                    <div key={index} ref={el => (tabRefs.current[tab.title] = el)}>
                                        <DecisionPointTabs tab={tab.title} activeTab={activeTab.title} onClick={() => handleTabClick(tab)}>
                                            {tab.title}
                                            {tab.challenge === "" && index + 1 === challenges.length && isPreviousChallengeEmpty ? (
                                                <sup
                                                    className="align-middle bg-white text-xs text-blue-800 hover:text-blue-950	px-1"
                                                    style={{
                                                        fontSize: "9px",
                                                        top: "-9px"
                                                    }}
                                                >
                                                    NEW
                                                </sup>
                                            ) : (
                                                ""
                                            )}
                                            {decisionPointsFromLocalStorageState.includes(tab.title) ? (
                                                <sup
                                                    className="align-middle bg-red-600 text-xs text-blue-800 hover:text-blue-950	rounded-xl px-1"
                                                    style={{
                                                        fontSize: "9px",
                                                        top: "-9px"
                                                    }}
                                                ></sup>
                                            ) : (
                                                ""
                                            )}
                                        </DecisionPointTabs>
                                    </div>
                                ))}
                            </div>
                            <div className="align-middle">
                                <HiChevronRight
                                    size={40}
                                    className={`scroll_decision_point_button ${!isRightDisabled && " hover:opacity-80"}`}
                                    onClick={slideRight}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="flex items-center justify-center auto-cols-auto">
                            <div
                                className="flex rounded overflow-x-auto items-center w-[80vw] scroll whitespace-nowrap scroll-smooth scrollbar-hide tabs-container "
                                id="slider"
                            >
                                {challenges.map((tab, index) => (
                                    <div
                                        key={index}
                                        ref={el => {
                                            tabRefs.current[tab.title] = el;
                                        }}
                                    >
                                        <DecisionPointTabs tab={tab.title} activeTab={activeTab.title} onClick={() => handleTabClick(tab)}>
                                            {tab.title}
                                            {tab.challenge === "" && index + 1 === challenges.length && isPreviousChallengeEmpty ? (
                                                <sup
                                                    className="align-middle bg-white text-xs text-blue-800 hover:text-blue-950	px-1"
                                                    style={{
                                                        fontSize: "9px",
                                                        top: "-9px"
                                                    }}
                                                >
                                                    NEW
                                                </sup>
                                            ) : (
                                                ""
                                            )}
                                            {decisionPointsFromLocalStorageState.includes(tab.title) ? (
                                                <sup
                                                    className="align-middle bg-red-600 text-xs text-blue-800 hover:text-blue-950	rounded-xl px-1"
                                                    style={{
                                                        fontSize: "9px",
                                                        top: "-9px"
                                                    }}
                                                ></sup>
                                            ) : (
                                                ""
                                            )}
                                        </DecisionPointTabs>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex items-center justify-end gap-2 col-span-1 flex-wrap">
                    {loading ? (
                        <LoadingScreen />
                    ) : (
                        <>
                            {!published && (
                                <>
                                    <Tooltip content={generateNewDecisionTooltipMessage} placement="bottom-end" className={generateNewDecisionTooltipStyle}>
                                        <Button
                                            onClick={() => {
                                                if (!isGenerating) {
                                                    setIsGenerating(true);
                                                    generateNewDecisionPoint();
                                                    setTimeout(() => setIsGenerating(false), 1000);
                                                }
                                            }}
                                            className={generateNewDecisionButtonStyle}
                                            disabled={isPreviousChallengeEmpty || isGenerating}
                                        >
                                            {" "}
                                            {generateDecisionButtonName}
                                        </Button>
                                    </Tooltip>

                                    <Tooltip content={addNewDecisionPointToolTipMessage} placement="bottom-end" className={addNewDecisionToolTipStyle}>
                                        <Button disabled={isPreviousChallengeEmpty} className={addNewDecisionButtonStyle} onClick={newDecisionPoint}>
                                            {" "}
                                            Add{" "}
                                        </Button>
                                    </Tooltip>
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
            <div className="mt-4">
                {activeTab && (
                    <DecisionPoint
                        decisionPointTitle={activeTab.title}
                        published={published}
                        caseletId={caseletId}
                        setActiveTabToChallenge={setActiveTabFromDecisionPoint}
                        isDecisionPointGenerating={generatingNewDecisionPoint}
                        sendNewOptionFlag={getNewOptionFlag}
                    />
                )}
            </div>
            <Alert showAlert={showAlert} handleStayEditing={handleStayEditing} handleDiscardChanges={handleDiscardChanges} />
        </div>
    );
};

export default Challenges;
